import requestFunctions from "../../functions/requestFunctions";


export const state = {
  ORDERS_ITEM: {},
  ORDERS_LIST: [],
  ORDERS_TABLE_DATA: [],
  ORDERS_LIST_DATA: [],
  ORDERS_TOTAL_ROWS: 0
}

export const getters = {
  GET_ORDERS_ITEM: (state) => {
    return state.ORDERS_ITEM;
  },
  GET_ORDERS_LIST: (state) => {
    return state.ORDERS_LIST;
  },
  GET_ORDERS_TABLE_DATA: (state) => {
    return state.ORDERS_TABLE_DATA;
  },
  GET_ORDERS_LIST_DATA: (state) => {
    return state.ORDERS_LIST_DATA;
  },
  GET_ORDERS_TOTAL_ROWS: (state) => {
    return state.ORDERS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_ORDERS_ITEM(state, item) {
    state.ORDERS_ITEM = item;
  },
  UPDATE_ORDERS_LIST(state, list) {
    
    state.ORDERS_LIST = list.data;
    state.ORDERS_TABLE_DATA = [];
    state.ORDERS_LIST_DATA = [];

    state.ORDERS_TOTAL_ROWS = list.total;
    list = list.data;
    
    list.forEach(el => {

      let status = '';

      if(el.status === 'active')  { status = 'Активна' }
      if(el.status === 'paused')  { status = 'Отложена'  }
      if(el.status === 'success') { status = 'Выполнена' }
      if(el.status === 'canceled'){ status = 'Отмена' }
      if(el.status === 'archive') { status = 'Архив' }

      let user = '';

      let fullname = '';

      if (el.profile_name3) {
        fullname = fullname + el.profile_name3 + ' ';
      }
      if (el.profile_name1) {
        fullname = fullname + el.profile_name1 + ' ';
      }
      if (el.profile_name2) {
        fullname = fullname + el.profile_name2 + ' ';
      }

      if(fullname !== ''){
        user = fullname;
      }

      if (el.user_phone) {
        user = user + ', ' + el.user_phone;
      }

      let company = el.company_name ? el.company_name : '-';

      state.ORDERS_TABLE_DATA.push({
        'id' : el.id,
        'created_at' : el.created_at,
        'title' : el.title,
        'profile_fullname' : user,
        'company_name' : company,
        'sum'       : el.sum,
        'city_name' : el.city_name ? el.city_name : '',
        'qnt'       : el.qnt_ready + ' / ' + el.qnt,
        'status'    : status,
        'uuid'      : el.uuid
      });

      let order_name = '№' + el.id + ' от ' + el.created_at + ', ' + el.title;

      if(user !== ''){
        order_name = order_name + ', ' + user;
      }

      if(company !== ''){
        order_name = order_name + ', ' + company;
      }

      state.ORDERS_LIST_DATA.push({
        uuid: el.uuid,
        id: el.id,
        name: order_name,
      });

    });
  },
}


export const actions = {

  async FETCH_ORDERS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/orders/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ORDERS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_ORDERS_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/orders';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ORDERS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_ORDERS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/orders';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_ORDERS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/orders/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_ORDERS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/orders/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}